// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Project } from '@/project/api/types';
import { ProjectCustomerLabel } from '@/project/components/project-customer-label';
import { ProjectProductsLabel } from '@/project/components/project-products-label';
import { getInterval } from '@/project/utilities/get-interval';
import { Box, Divider, Stack, Typography } from '@mui/material';

interface Props {
  project: Project;
}

export function ProjectTimelineTooltip(props: Props) {
  const interval = getInterval(props.project);

  return (
    <Stack minWidth={200}>
      <Stack
        padding={1}
        spacing={3}
        direction="row"
        justifyContent="space-between"
      >
        <Typography variant="subtitle2">{props.project.name}</Typography>
        {interval && (
          <Typography variant="body2">
            {interval.toLocaleString({ dateStyle: 'medium' })}
          </Typography>
        )}
      </Stack>
      <Divider />
      <Box
        display="grid"
        padding={1}
        rowGap={1}
        columnGap={2}
        gridTemplateColumns="auto 1fr"
      >
        <Typography variant="body2">Customer</Typography>
        <ProjectCustomerLabel customer={props.project.customer} />
        <Typography variant="body2">Default location</Typography>
        <Typography
          variant="body2"
          color={
            props.project.defaultLocation ? 'text.primary' : 'text.secondary'
          }
        >
          {props.project.defaultLocation?.name ?? 'Not set'}
        </Typography>
        <Typography variant="body2">Products</Typography>
        <ProjectProductsLabel
          variant="body2"
          status={props.project.status}
          assignments={props.project.assignments}
        />
      </Box>
    </Stack>
  );
}
